<template>
<div class="row">
    <div class="col-md-4 col-12">
        <div class="card">
            <div class="card-body">
                <div class="text-left">
                    <a class="h5 text-primary"><i class="fas fa-angle-left"></i> &nbsp;Home</a>
                    <h4 class="font-weight-bold py-3">Cash Drawer</h4>

                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div id="datepicker-trigger" class="datepicker-trigger pl-3" v-on:click="CashDrawerdate(dateOne)">




                    <airbnb-style-datepicker :trigger-element-id="'datepicker-trigger'"
                                             :mode="'single'"
                                             :inline="true"
                                             :fullscreen-mobile="false"
                                             @date-one-selected="val => { dateOne = val }"
                                             :months-to-show="1"
                                             :showShortcutsMenuTrigger="false"
                    />
                </div>

            </div>

        </div>

    </div>
    <div class="col-md-8 col-12">

        <div class="card">
            <div class="card-body">
                <div class="text-center">
                    <h6 class="font-weight-bold">{{t_date}}</h6>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <table>
                    <tbody>
                    <tr>
                        <td>
                            <div class="text-left">
                                <p class="text-gray"><i class="bi bi-download"></i> in Cash</p>
                                <h5 class="text-dark pl-3">431,000</h5>
                            </div>


                            <div class="text-left pt-3">
                                <p class="text-gray"><i class="bi bi-unlock"></i> Opening Balance</p>
                                <h5 class="text-dark pl-3">431,000</h5>
                            </div>

                        </td>
                        <td>
                            <div class="float-right">
                                <div class="text-left">
                                    <p class="text-gray"><i class="bi bi-upload"></i> out Cash</p>
                                    <h5 class="text-dark pl-3">431,000</h5>
                                </div>


                                <div class="text-left pt-3">
                                    <p class="text-gray"><i class="bi bi-lock"></i> Opening Balance</p>
                                    <h5 class="text-dark pl-3">431,000</h5>
                                </div>

                            </div>

                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>
        </div>
        <h6 class="py-2">Sale Details</h6>
        <div class="card">
            <div class="card-body">
                <table class="table table-hover">

                    <tbody>
                    <tr>
                        <th scope="row">#</th>
                        <td>
                            <p>Order id: #ORD12019</p>
                        </td>
                        <td>
                            <h6 class="text-success">+400</h6>
                        </td>
                        <td><h6>1,1200</h6></td>

                    </tr>
                    <tr>
                        <th scope="row">#</th>
                        <td>
                            <p>Order id: #ORD12019</p>
                        </td>
                        <td>
                            <h6 class="text-success">+400</h6>
                        </td>
                        <td><h6>1,1200</h6></td>

                    </tr>
                    <tr>
                        <th scope="row">#</th>
                        <td>
                            <p>Order id: #ORD12019</p>
                        </td>
                        <td>
                            <h6 class="text-success">+400</h6>
                        </td>
                        <td><h6>1,1200</h6></td>

                    </tr>


                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>



</template>

<script>
    import format from 'date-fns/format'
    export default {
        name: "CashDrawer",
        data() {
            return {
                dateFormat: 'D-MM-YYYY',
                dateOne: '',
                dateTwo: '',
                t_date: moment().format('D-MM-YYYY'),
            }
        },
        methods: {

            CashDrawerdate(dateOne)
            {

                    this.t_date = format(dateOne, this.dateFormat);
                    console.log(dateOne);
            }
        }
    }
</script>

<style scoped>

</style>